import {throwSecureSubmissionError, WizardApiError} from './index'
import {CORRELATION_ID_HEADER, getOrCreateWizardCorrelationId} from '../../../shared/service/correlation-id'

const API_URL = (process.env.REACT_APP_API_URL || '/api').replace(/\/+$/, '')
const accessUrl = (token: string) => `${API_URL}/wizard/submission/secure-view/${encodeURIComponent(token)}`

export type PmAccessStatus = {
  trusted: boolean
  maskedMobile: string
  trustExpiresAtUtc?: string
  challengeId?: string
  otpExpiresAtUtc?: string
  debugOtp?: string
  retryAfterSeconds: number
}

export type PmOtpChallenge = {
  challengeId: string
  maskedMobile: string
  expiresAtUtc: string
  debugOtp?: string
  retryAfterSeconds: number
}

export type PmOtpVerification = {
  verified: boolean
  trustExpiresAtUtc?: string
  message?: string
  requiresNewCode: boolean
}

async function request<T>(token: string, path: string, body?: object): Promise<T> {
  const response = await fetch(`${accessUrl(token)}/${path}`, {
    method: body ? 'POST' : 'GET',
    cache: 'no-store',
    credentials: 'include',
    headers: {'Content-Type': 'application/json', [CORRELATION_ID_HEADER]: getOrCreateWizardCorrelationId()},
    body: body ? JSON.stringify(body) : undefined,
  })
  if (!response.ok) return throwSecureSubmissionError(response)
  return response.json()
}

export const getPmAccessStatus = (token: string) => request<PmAccessStatus>(token, 'access-status')
export const sendPmOtp = (token: string) => request<PmOtpChallenge>(token, 'otp/send', {})
export const verifyPmOtp = (token: string, challengeId: string, code: string) =>
  request<PmOtpVerification>(token, 'otp/verify', {challengeId, code})

export function isPmAccessFailure(error: unknown): error is WizardApiError {
  return error instanceof WizardApiError && !!error.code && [
    'PM_OTP_REQUIRED', 'PM_EMAIL_REQUIRED', 'PM_MOBILE_UNAVAILABLE', 'PM_SUBMISSION_UNAVAILABLE',
  ].includes(error.code)
}
